module.exports = __webpack_public_path__ + "media/images/workout-preview-9d2aa5a8ed0ad578e924800a7d65c34f.webp";